import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M15.5 6V3.1a1 1 0 0 0-.629-.929l-4-1.6a1 1 0 0 0-.742 0L5.87 2.275a1 1 0 0 1-.742 0L1.186.697a.5.5 0 0 0-.686.467v9.582a1 1 0 0 0 .629.929l4 1.6a1 1 0 0 0 .742 0l1.921-.77M5.5 2.346v11M10.5.5v5M12.5 10.3a.25.25 0 0 1 .25.25M12.25 10.55a.25.25 0 0 1 .25-.25M12.5 10.8a.25.25 0 0 1-.25-.25M12.75 10.55a.25.25 0 0 1-.25.25",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  fill: "transparent"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.5 7.55a3 3 0 0 1 3 3c0 1.28-1.792 3.717-2.606 4.758a.501.501 0 0 1-.788 0c-.814-1.04-2.606-3.478-2.606-4.759a3 3 0 0 1 3-3Z",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  fill: "transparent"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }